import Api from "../config/api";
import axios from "axios";

export default {
    namespaced: true,
    state: {
        app:{},
        loaded: false,
    },
    mutations: {
        set(state, payload) {
            state.app = payload;
            state.loaded = true;
            if (state.app.name) {
                window.document.title = state.app.name;
            }
        },
    },
    getters: {},
    actions:{
        loadPreset(context) {
            const prefix = "api/v1/user/preset?_t"+Math.random();
            const url = Api.url.replace('api/v1', prefix);

            axios.get(url).then(res => {
                if (res.data) {
                    context.commit('set',res.data.data);
                }
            }).catch(() => {
            });
        }
    }
}
